// src/context/PublicRoute.js
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const auth = localStorage.getItem("currentUser"); 

  return auth ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
